import React, { Component } from 'react';
import { connect } from 'react-redux'
import Modal from 'react-modal';
import PropTypes from 'prop-types'
import {toastr} from 'react-redux-toastr'
import { MODAL_SLIDER_SHARE, hideModal } from '../../../../../../modules/modals';
import { deleteSlider } from '../../../../actions';
import SwitchField from '../../../../../helpers/Fields/SwitchField';

class ShareModal extends Component {
  static contextTypes = {formatMessage: PropTypes.any};

  handleClose = () => {
    const { hideModal } = this.props;
    hideModal({ modalType : MODAL_SLIDER_SHARE});

  }

  getTitle = () => {
    const {formatMessage} = this.context
    let text = "frmTitleShareSlider"
    return <div className="create-dialog-modal-content__title">{formatMessage(text)}</div>;
  }


  copy = () => {
    var copyText = document.getElementById("slider_frame");
    const {formatMessage} = this.context
    /* Select the text field */
    copyText.select();
    copyText.setSelectionRange(0, 99999); /* For mobile devices */

    /* Copy the text inside the text field */
    document.execCommand("copy");
    toastr.success(formatMessage('titleFrameCopy'), formatMessage('msgFrameCopy'))
  }


  render() {
    const {formatMessage} = this.context
    const { zIndex, id} = this.props;
    return (
      <Modal
          isOpen = {true}
          style = {{
              overlay : {zIndex},
          }}
          onRequestClose={this.handleClose}
          overlayClassName = "custom-modal"
          className = "custom-modal-content create-dialog-modal-content"
      >
          <div className="create-dialog-modal-content__header">
              {
                this.getTitle()
              }
              <div
                  onClick={this.handleClose}
                  className="create-dialog-modal-content__close"
              ></div>
          </div>
          <div className="create-dialog-modal-content__body">
            <div className="create-dialog-form">
              <div className="row mb-5">
                <textarea rows={4} id="slider_frame" style={{width: '100%', border: '1px solid #d9d9d9'}}>
                  {`<iframe src="https://${window.location.hostname}/slider/view/${id}" width="100%" height="570" frameborder="0"></iframe>`}
                </textarea>
              </div>
              <div className="flex" style={{alignItems: 'center', justifyContent:'center'}}>
                <button className="btn btn-primary" onClick={this.copy} >{formatMessage('btnModalCopy')}</button>
              </div>
            </div>
          </div>
      </Modal>
    );
  }
}



const mapStateToProps = (state, ownProps) => ({
})

const mapDispatchToProps = {
  hideModal,
  deleteSlider,
}

export default connect(mapStateToProps, mapDispatchToProps)(ShareModal)



// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/Sliders/components/PresentationItems/components/ShareModal/index.jsx